import Storage from "@/utils/storage"

export default {
  methods: {
    async setCartItemNumber(number) {
      await Storage.set("cartItems", number.toString());
      this.dispatchEvent();
    },
    async dispatchEvent() {
      const cartItems = await Storage.get("cartItems") || 0

      window.dispatchEvent(
        new CustomEvent("localStorageCartItemsChanged", {
          detail: {
            cartItems: Number(cartItems),
          },
        })
      );
    },
    // item_count arrives as a number, and the native Preferences plugin only
    // accepts strings: it dropped the value and stored "" instead, so the very
    // path meant to resync a stale badge was the one blanking it.
    async forceCartItemDisplay(quantity) {
      const cartItems = await Storage.get("cartItems")

      if (
        cartItems == undefined || cartItems == null || cartItems != quantity
      ) {
        await this.setCartItemNumber(Number(quantity) || 0);
      }
    },
  },
};
